import { useEffect, useMemo, useState } from 'react';
import { debounce } from 'marketplace-ui-common/utils/debounce';
import { useGenerateTitleQuery } from '../../__generated__/chirp/com/hubspot/reviews/rpc/ReviewsRpc.hooks';
export function useGeneratedReviewTitle({
  answers,
  ratings,
  entityName,
  reviewType
}) {
  const [formattedAnswers, setFormattedAnswers] = useState(() => {
    const answersWithoutTitle = structuredClone(answers);
    delete answersWithoutTitle.TITLE;
    return answersWithoutTitle;
  });
  const [formattedRatings, setFormattedRatings] = useState(structuredClone(ratings));
  const hasContent = !Object.values(formattedAnswers).every(value => !value);
  const [skip, setSkip] = useState(!hasContent);
  const {
    data,
    error,
    loading
  } = useGenerateTitleQuery({
    variables: {
      answers: formattedAnswers,
      ratings: formattedRatings,
      entityName,
      // @ts-expect-error Asset review type not yet supported
      type: reviewType
    },
    skip
  });
  const debouncedUpdate = useMemo(() => debounce((newAnswers, newRatings) => {
    const answersWithoutTitle = structuredClone(newAnswers);
    delete answersWithoutTitle.TITLE;
    setFormattedAnswers(answersWithoutTitle);
    setFormattedRatings(structuredClone(newRatings));
    const hasNewContent = !Object.values(answersWithoutTitle).every(value => !value);
    setSkip(!hasNewContent);
  }, 300), []);

  // Update when answers or ratings change
  useEffect(() => {
    debouncedUpdate(answers, ratings);
  }, [answers, ratings, debouncedUpdate]);
  return {
    generatedTitle: data && !error ? data.title : undefined,
    loading
  };
}